import React, { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.log(`Error boundary caught an error: ${error}, ${errorInfo}`);
  }

  render() {
    const { hasError } = this.state;
    if (hasError) {
      <div style={{ padding: '16px' }}>
        <h2>
          Oops, we’ve run into a technical issue. Please close the website and come back later.
        </h2>
      </div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
